import styles from "./OurWorkSection.module.scss";
// import { our_work } from "../../../../constants/our_work";
import { useSite } from "../../../../context/TranslationContext";
import user from "../../../../assets/images/pages/home/our-work/UserCircle.svg";
import wallet from "../../../../assets/images/pages/home/our-work/Wallet.svg";
import pakage from "../../../../assets/images/pages/home/our-work/Package.svg";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { useEffect } from "react";
import { fetchTranslation } from "../../../../redux/Slices/translationDataSlice";

const OurWorkSection = () => {
  const backgrounds = ["#DFECE2", "#F8F4EE", "#FDE8D7"];
  const { data } = useSelector((state: RootState) => state.translationData);
  const dispatch=useDispatch()

  const our_work = [
    {
      id: 0,
      logo: user,
      title: data?.how_we_work_registration_title,
      description: data?.how_we_work_registration_text,
    },
    {
      id: 1,
      logo: wallet,
      title: data?.how_we_work_payment_title,
      description: data?.how_we_work_payment_text,
    },
    {
      id: 2,
      logo: pakage,
      title: data?.how_we_work_receive_title,
      description: data?.how_we_work_receive_text,
    },
  ];
 
  return (
    <div id={styles.our_work}>
      <div className="container">
        <div className={styles.our_work}>
          <h1 className={styles.section_title}>{data?.how_we_work} </h1>
          <div className={styles.our_work_cards}>
            {our_work.map((work, index) => {
              return (
                <div
                  className={styles.work_card}
                  key={index}
                  style={{ background: backgrounds[index % 3] }}
                >
                  <div className={styles.card_head}>
                    <div className={styles.card_logo}>
                      <img src={work.logo} alt="logo" />
                    </div>
                    <h1 className={styles.content_title}>{work.title}</h1>
                  </div>
                  <p className={styles.content_description}>
                    {work.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurWorkSection;
